import React from 'react';
import PropTypes from 'prop-types';
import PageAlert from '../PageAlert';
import FormattedText from '../FormattedText';
import QuestionIcon from '../../../public/static/icons/question-icon.svg';
import { DEFAULT_COUNTRY_CODE } from '../../../utils/constants';

import styles from './index.module.scss';

const SubmissionError = ({
  onCloseClick,
  message = '',
  additionalMessage = '',
  subline = '',
  className = '',
}) => {
  const helpNumber = DEFAULT_COUNTRY_CODE === 'GB' ? '0800 032 4001' : '+353 1 417 7777';
  const helpEmail =
    DEFAULT_COUNTRY_CODE === 'GB' ? 'enquiries.info@concern.net' : 'info@concern.net';
  const defaultSubline = `You can always contact <a href="mailto:${helpEmail}">${helpEmail}</a> or ${helpNumber} for help.`;

  return (
    <PageAlert
      onClose={onCloseClick}
      className={`${styles['submission-alert']} ${className}`}
      role="alert"
      aria-labelledby="submission-error-title"
    >
      {message && (
        <FormattedText
          className={styles['submission-alert-message']}
          data-component="donation-form-submit-error-message"
          text={message}
        />
      )}

      {additionalMessage && (
        <FormattedText
          text={additionalMessage}
          className={styles['submission-alert-additionalMessage']}
        />
      )}

      <div className={styles['submission-alert-subline-wrapper']}>
        <div className={styles['submission-alert-icon']}>
          <QuestionIcon />
        </div>
        <FormattedText
          text={subline || defaultSubline}
          className={styles['submission-alert-subline']}
        />
      </div>
    </PageAlert>
  );
};

SubmissionError.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
  message: PropTypes.string,
  additionalMessage: PropTypes.string,
  subline: PropTypes.string,
  className: PropTypes.string,
};

export default SubmissionError;
